import { t } from "i18next";
import styles from "./PriceTotal.module.scss";

type PriceTotalProps = {
    originalPriceTotal: number;
    priceAfterDiscount: number;
};

const PriceTotal = ({ originalPriceTotal, priceAfterDiscount }: PriceTotalProps) => {
    const hasDiscount = priceAfterDiscount != originalPriceTotal;

    return (
        <div className={styles.priceTotal}>
            {hasDiscount && (
                <span className={styles.priceTotalCrossed}>
                    {originalPriceTotal} {t("global.currency.czk")}
                </span>
            )}
            <span className={styles.priceTotalSum}>
                {hasDiscount ? Math.max(0, priceAfterDiscount) : originalPriceTotal} {t("global.currency.czk")}
            </span>
            {hasDiscount && (
                <div className={styles.discountInfo}>
                    {t("buy.discount.ev")}
                </div>
            )}
        </div>
    );
};

export default PriceTotal;
